import React from 'react';
import { Link } from 'react-router-dom';

const Pricing = () => {
  const plans = [
    {
      name: 'Brazil Trademark Filing',
      description: 'National filing with local representation and clear scope.',
      price: 'From USD 530',
      fees: 'First class, Brazilian government fee included · each extra class USD 430',
      features: [
        'Quick search for identical marks included',
        'Filing, updates and certificate when approved',
        '12 months of Brazil Trademark Watch included',
        'Individuals pay a 50% lower government fee',
      ],
      link: { to: '/order', label: 'Order online →' },
    },
    {
      name: 'Brazil Trademark Watch',
      description: "Weekly check of Brazil's trademark gazette, with alerts in English.",
      price: 'USD 150',
      fees: 'Per watched mark / year · up to three classes',
      features: [
        'Every Tuesday gazette checked',
        'Identical, similar and sound-alike filings',
        'Opposition deadline in every alert',
      ],
      link: { to: '/brazil-watch', label: 'See Brazil Watch →' },
    },
    {
      name: 'IP Firms & Portfolios',
      description: "Coordinated filings and watch across your clients' marks.",
      price: 'By Quote',
      fees: 'Partner prices confirmed in writing',
      features: [
        'A separate Brazilian application for each class',
        'Portfolio watch rates from five marks',
        'Coordinated reporting for your portfolio',
      ],
    },
  ];

  return (
    <section id="pricing" className="py-20 bg-white scroll-mt-24 relative">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-text mb-4">
          Clear Scope. Predictable Fees.
          </h2>
          <p className="text-text/70 mb-6 text-lg">Fixed prices, shown before you order. The Brazilian government fee is included, and nothing extra is charged when your trademark is approved.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-10">
          {plans.map((plan, index) => (
            <div
              key={index}
              className="bg-background-auxiliary rounded-3xl shadow-sm p-8 hover:shadow-md border border-gray-100/50 hover:border-primary/30 group"
            >
              <h3 className="text-2xl font-bold text-text mb-3">
                {plan.name}
              </h3>
              <p className="text-text/70 mb-8 text-base">{plan.description}</p>
              <div className="mb-4">
                <span className="text-4xl font-bold text-primary whitespace-nowrap">
                  {plan.price}
                </span>
              </div>
              <p className="text-sm text-text/60 mb-4">{plan.fees}</p>
              {plan.features && plan.features.length > 0 && (
                <ul className="space-y-2 text-sm text-text/80">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-center gap-2">
                      <span className="text-primary font-bold" aria-hidden="true">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
            )}
            {plan.link && (
              <Link to={plan.link.to} className="mt-6 inline-block text-primary hover:text-primary-hover font-semibold">
                {plan.link.label}
              </Link>
            )}
          </div>
        ))}
      </div>

        <p className="text-center text-sm text-text/70 max-w-2xl mx-auto mb-8">
          Prices assume a standard list of products and services (pre-approved by INPI, Brazil's trademark office). The government fee follows INPI's official table and any reduction you qualify for. Payment is made in advance.
        </p>

        <div className="text-center">
          <p className="text-text/70 mb-6 text-lg">
            Not sure which classes you need? Ask for a free proposal. IP firms: partner prices are confirmed in writing.
          </p>
          <Link
            to="/request-proposal"
            className="inline-block bg-primary text-white px-10 py-4 rounded-xl hover:bg-primary-hover font-semibold shadow-md hover:shadow-lg"
          >
            Ask for a free proposal
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
